
import {forkJoin as observableForkJoin,  Observable ,  ObservableInput } from 'rxjs';

import {map, catchError, mergeMap} from 'rxjs/operators';
/**
 * Authentication service
 * xsecurity generator
 **/

// Core
import { Injectable } from '@angular/core';

//Vanilla
//lodash
import _set from 'lodash-es/set';
import _get from 'lodash-es/get';
import _forEach from 'lodash-es/forEach';
import _concat from 'lodash-es/concat';
import { HttpClient } from '@angular/common/http';


// Import RxJs required methods



@Injectable()
export class ViewService {

    //XXX Dummy for now, need to get real user rights once complete
    private view: Observable<any>;

    private viewsUrl = sessionStorage.getItem('$wui_url')+"config/views/view.json";

    public display = {"root":""};

    constructor(private http: HttpClient) {}

    /**
     * getView
     * get view.json file
     */
    public getView(): Observable<any>{
        if (!this.view){
            this.view = this.http.get(this.viewsUrl).pipe(
                mergeMap((res: Response): ObservableInput<any> => {
                    const view: any = res;
                    const pagesDetails: Observable<any>[] = [];

                    _forEach(view.pages, (app: any, appName: string) => {
                        _forEach(app.step, (stepFile: string, stepName: string) => {
                            if (stepFile != "") {
                                pagesDetails.push(
                                    this.getViewPartial(stepFile, 'pages').pipe(
                                        map(data => ({
                                            data,
                                            path: ['pages', appName, 'step', stepName]
                                        })))
                                )
                            }
                        })
                    });

                    return observableForkJoin(pagesDetails).pipe(
                        map(pagesDetails => {
                            return pagesDetails.reduce((agg, pageDetails) => {
                                _set(agg, pageDetails.path, pageDetails.data);
                                return agg;
                            }, view);
                        }));

                }),
                catchError((error: any): any => { }),);
        }

        return this.view;
    }

    /**
     * getViewPartial
     * @param {string} _fileName : partial view file to get content
     * @param {string} _responsePath : wher to get data from file json content
     */
    public getViewPartial(_fileName: string, _responsePath: string= ""): Observable<any>{
        return this.http.get(sessionStorage.getItem('$wui_url')+"config/views/" + _fileName + ".json" ).pipe(
            map( (res: Response) => _get(res, _responsePath)),
            catchError( (error:any):any => {}),);
    }

    /**
     * setPagesOnBreadcrumb
     * @param _steps : pages to insert
     * @param _bcTarget : target BreadCrumb
     */
    public getPagesOnBreadcrumb(_steps: any, _bcTarget: any, _bcProvisionnalTarget): any{
        // let i=0;
        _forEach( _steps, (step: any, stepName: string) => {
            if(step){
                _forEach (step, (pageConfig: any, pageName)=>{

                    if (pageConfig.first){
                        _bcTarget = _concat( _bcTarget, [pageConfig] );
                    }else{
                        _set( _bcProvisionnalTarget, pageName, pageConfig );
                    }

                    // i++;
                });
            }
        } );
        return {items: _bcTarget, provisionalItems: _bcProvisionnalTarget};
    }



}
